import React from 'react';
import clsx from 'clsx';

const TabActions = ({ className, children }) => (
  <div className={clsx('aridhia-tab-actions', className)}>
    <div className="actions">
      {children}
    </div>
  </div>
);

export default TabActions;
